import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import InfoHeader from "../../../comman/infoHeader";
import PageHeader from "../../PageHeader";
import http from "../../../services/HttpService";
import config from "../../../config.json";
import PageSizeOptions from "../../PageSizeOptions";
import Pagination from "../../../comman/pagination";
import { paginate, calculateIndex } from "../../../utlis/paginate";
import Moment from "react-moment";
import EditPartner from "./EditPartner";
import ActiveDeactiveHistory from "./ActiveDeactiveHistory";
import Swal from "sweetalert2";
import ReminderAlertMessage from "../../ReminderAlertMessage";
import authService from "../../../services/authService";
import TableLoader from "../../../comman/TableLoader";
import {
  recruitersReceived, loadRecruiters,
  filterRecruitersReceived, loadRecruitersByFilter,
  SendReminder, getReminderStatus, getAllRecruiters, getFilterAllRecruiters,
  loadRecruiterBprmForm,
  getRecruiterBprmForm,
  filterAllRecruiterStatus,
  getFilterRecruiters,
  recCurrentWfTaskReceived,
  receivedRecruiterById
} from "../../../app/store/recruiter";
import { getCurrentUser } from "../../../app/store/auth";
import { setCurrentPageTitle, setCurrentRoute } from "../../../app/store/layoutUI";
import { getAlert } from "../../../services/appAlerts";
import { Tab, Tabs } from "react-bootstrap";
import { getFieldData, getFormatedNumber } from "../../../services/appService";
import Document from "../../PortalForms/Document";
import WorkflowElement from "../../../app/components/WorkflowElement";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived } from "../../../app/store/documents";
import { receivedSubcontractorById, subsCurrentWfTaskReceived } from "../../../app/store/subcontractor";
import { formLibraryReceived } from "../../../app/store/forms";
import AchInformation from "../../../ReviewTools/AchInformation";
import InsuranseInformation from "../../../ReviewTools/InsuranseInformation";
import { candidateAppsReceived, receivedCandidateById } from "../../../app/store/candidate";
import { getRecruiterPartners, loadRecruiterPartners } from "../../../app/store/partner";

export default function ListRecruiter() {

  let route = [
    { url: "", name: "System Administration" },
    { url: "", name: "Manage Partners" },
  ];

  const param = useParams();
  const type = param?.type;

  if (type === "partner") {
    route = [
      { name: "System Administration", url: "" },
      { name: "Manage Entities", url: "" },
    ];
  } else {
    route = [
      { name: "Onboarding and Contracts", url: "" },
    ];
  }

  const currentUser = getCurrentUser();

  const [partnerType, setPartnerType] = useState("Recruiter");
  const [actionType, setActionType] = useState("action");
  const [recruiters, setRecruiters] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState("");
  const [recId, setRecId] = useState("");
  const [recruiterId, setRecruiterId] = useState("");
  const [recName, setRecName] = useState("");
  const [recEmail, setRecEmail] = useState("");
  const [dataType, setDataType] = useState("");
  const [selectedRecruiterId, setSelectedRecruiterId] = useState(0);
  const [selectedTab, setSelectedTab] = useState("home");

  const [viewRowType, setViewRowType] = useState("");
  const [selectedKey, setSelectedKey] = useState(-1);
  const [selectedFormKey, setSelectedFormKey] = useState(-1);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");

  const [achType, setAchType] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [selectedInfo, setSelectedInfo] = useState("");
  const [editDurType, setEditDurType] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

  const [filterShowHide,setFilterShowHide]=useState(false);
  const [filterRecruiterList, setFilterRecruiterList] = useState([]);

  const allRecruiters = useSelector(getAllRecruiters);
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);
  const remiderStatus = useSelector(getReminderStatus);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
  const recruiterFilterData = useSelector(getFilterRecruiters)
  const recruiterPartnersSelector = useSelector(getRecruiterPartners);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Recruiters"))
  }, []);

  useEffect(() => {
    if (recruiterFilterData === "") {
      dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    } else if (recruiterFilterData.dataType === "filter") {
      // console.log("recruiterFilterData", recruiterFilterData)
      setRecId(recruiterFilterData.id);
      setRecName(recruiterFilterData.name);
      setRecEmail(recruiterFilterData.entity);
    }
  }, [selectedTab]);

  useEffect(() => {
    console.log("allRecruiters changed", allRecruiters)
    if (allRecruiters.length > 0) {
      if (allRecruiters.length > 0)
        setRowsCount(allRecruiters[0].totalPartners);

      setRecruiters(allRecruiters);
      handleCloseDocumentView();
    }
  }, [allRecruiters]);

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(5)
    getPagedData(filterAllRecruiters, 1, 5);
  }, [filterAllRecruiters]);

  useEffect(() => {
    // dispatch(loadAppDefaultData(1));
    setWfTask({ formId: config.formIds.recruiter, ciid: 0 });
    dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
  }, []);

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllRecruiters, currentPage, pageSize);
      else
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    }
  }, [remiderStatus])

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (dataType === "filter")
      getPagedData(filterAllRecruiters, page, pageSize)
    else
      dispatch(loadRecruiters(pageSize, page, partnerType));
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (dataType === "filter")
      getPagedData(filterAllRecruiters, currentPage, currentTarget.value);
    else
      dispatch(loadRecruiters(currentTarget.value, currentPage, partnerType));
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalPartners);

    setRecruiters(items);
    handleCloseDocumentView();
  };

  useEffect(() => {
    setFilterRecruiterList(recruiterPartnersSelector);
  }, [recruiterPartnersSelector])

  const handleModalShowHide = (item) => {
    setShowHide(!showHide);
    setSelectedObj(item);
  };

  const handleAddEditRecruiter = (data) => {
    if (data === "exit") {
      setSelectedTab("home");
      setSelectedObj("");
      setSelectedRecruiterId(0);
    }

    setTimeout(() => {
      if (dataType === "filter")
        getPagedData(filterAllRecruiters, currentPage, pageSize);
      else
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    }, 3000);
  };

  const handleTabOnSelect = (tab) => {
    setSelectedTab(tab)
  }

  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (dataType === "filter")
        getPagedData(filterAllRecruiters, currentPage, pageSize);
      else
        dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handleFilter = () => {
    setDataType("filter");
    var frmBody = new FormData();
    frmBody.append("id", recId || "");
    if (recruiterId && !recId)
      frmBody.append("id", recruiterId);

    frmBody.append("name", recName || "");
    frmBody.append("email", recEmail || "");
    frmBody.append("type", partnerType || "");
    dispatch(loadRecruitersByFilter(frmBody));
    dispatch(filterAllRecruiterStatus({
      "id": recId,
      "name": recName,
      "email": recEmail,
      "dataType": "filter",
    }));
  };

  const handleFilterCancel = (type) => {
    if (type === "close" && filterShowHide)
      setFilterShowHide(false);
    setDataType("");
    setRecId("");
    setRecName("");
    setRecEmail("");
    setCurrentPage(1);
    setPageSize(5)
    setRecruiterId("")
    dispatch(loadRecruiters(5, 1, partnerType))
    dispatch(filterAllRecruiterStatus(""))
  };

  const handlePartnerPerformer = () => {
    if (selectedRecruiterId > 0) {
      navigate("/ManagePartnerPerformer", {
        state: {
          obj: selectedObj,
          partner: "Recruiters",
          url: "Recruiter/partner",
        }
      })
    }

  }

  const getLastWorkflowTask = (workflowTasks) => {
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handlePartnerApplication = (item, app) => {
    // navigate("/CustomerApps", {
    //   state: {
    //     item: item,
    //     currentUser: currentUser,
    //     type: type,
    //     selectedApp: app.applicationId,
    //     appType: "partner",
    //     module: "Recruiter",
    //   }
    // })
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "partner",
        module: "Recruiter",
      }
    })
  }

  const handleSelectRecruiter = (item) => {
    setSelectedRecruiterId(item.fuid)
    setSelectedObj(item);
  }

  const handleResetSelection = () => {
    setSelectedRecruiterId(0);
    setSelectedObj(null);
  }

  const handlePermissionShowHide = () => {
    handleResetSelection()
    setSelectedTab("home");
  };

  const handlePermissionShowHide2 = () => {
    dispatch(loadRecruiters(pageSize, currentPage, partnerType));
    setSelectedTab("home");
  };

  const handleDocumentViewShowHide = (type, key, app) => {
    if (viewRowType === type) return;
    handleCloseDocumentView();
    setViewRowType(type);
    setSelectedInfo(type);
    setSelectedKey(key);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  };

  const handleCloseDocumentView = () => {
    setSelectedFormKey(-1);
    setViewFormType("");
    setUpdatedStateData("");
    setSelectedKey(-1);
    setViewRowType("");
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(candidateAppsReceived([]))
  }

  const handleViewRecruiterForm = (type, key, item) => {
    setSelectedKey(-1)
    setViewRowType("");
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    if (viewFormType === type) {
      setViewFormType("");
      setSelectedFormKey(-1);
      setUpdatedStateData()
    } else {
      setViewFormType(type);
      setSelectedFormKey(key);
      if (item.applications?.length > 0)
        setUpdatedStateData(item.applications[0].applicationData);
      else
        setUpdatedStateData(item.contact1.performerData);
    }
  }

  const handleNextTask = () => {
    console.log("")
  }

  const handleACHShowHide = (mod, type, item, key, app) => {
    if (achType === type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType(type);
    setInsuranceType("");
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const handleInsuranceShowHide = (mod, type, item, key, app) => {
    if (insuranceType === type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType("");
    setInsuranceType(type);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const closeACHInsu = () => {
    setSelectedInfo("");
    setSelectedKey(-1);
    setAchType("");
    setInsuranceType("");
    dispatch(receivedRecruiterById([]));
  }

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    if (!filterShowHide) {
      if (recruiterPartnersSelector.length === 0)
        dispatch(loadRecruiterPartners("Recruiter"));
    }
  }

  return (
    <React.Fragment>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none">
          <div className="card-header border-0 p-2">
            <div className="row">
              <div className="col-md-10">
                <PageSizeOptions
                  pageSize={pageSize}
                  onChange={handlePageSizeChanged}
                ></PageSizeOptions>
              </div>
              <div className="col-md-2 text-right">
                <button
                  className="btn btn-sm btn-outline-default btn-min-width"
                  //data-toggle="collapse"
                  //data-target="#collapseExample"
                  onClick={handleSearchShowHide}
                >
                  <i className="fa fa-search" aria-hidden="true"></i> Search
                </button>
              </div>
              {filterShowHide &&
              <div className="col-md-12">
                <div className="p-2 bg-secondary border mt-2" id="collapseExample">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label
                          htmlFor="recId"
                          className="form-control-label"
                        >
                          ID
                        </label>
                        <input
                          type="text"
                          name="recId"
                          id="recId"
                          className="form-control"
                          placeholder="ID"
                          value={recId}
                          onChange={({ currentTarget }) => setRecId(currentTarget.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-5">
                      {/* <div className="form-group">
                        <label
                          htmlFor="recName"
                          className="form-control-label"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          name="recName"
                          id="recName"
                          className="form-control"
                          placeholder="Name"
                          value={recName}
                          onChange={({ currentTarget }) => setRecName(currentTarget.value)}
                        />
                      </div> */}
                      <div className="form-group">
                        <label
                          htmlFor="recruiterId"
                          className="form-control-label"
                        >
                          Recruiter
                        </label>
                        <select
                          name="recruiterId"
                          id="recruiterId"
                          className="form-control"
                          onChange={({ currentTarget }) => setRecruiterId(currentTarget.value)}
                          value={recruiterId}
                        >
                          <option value="">Select</option>
                          {filterRecruiterList.map((item) => (
                            <option value={item.fuid}>{item.label} - {item.fuid}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label
                          htmlFor="recEmail"
                          className="form-control-label"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          name="recEmail"
                          id="recEmail"
                          className="form-control"
                          placeholder="Email"
                          value={recEmail}
                          onChange={({ currentTarget }) => setRecEmail(currentTarget.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 text-center ">
                      <button
                        className="btn-sm btn-outline-default mr-2"
                        onClick={() => handleFilter()}
                      >
                        <i className="fa fa-search mr-2" aria-hidden="true"></i>Search
                      </button>
                      <button
                        className="btn-sm btn-outline-default mr-2"
                        onClick={()=>handleFilterCancel("refresh")}
                      >
                        <i className="fa fa-refresh mr-2" aria-hidden="true"></i>Refresh
                      </button>
                      <button
                        className="btn-sm btn-outline-default mr-2"
                        //data-toggle="collapse"
                        //data-target="#collapseExample"
                        onClick={()=>handleFilterCancel("close")}
                      >
                        <i className="fa fa-close mr-2" aria-hidden="true"></i>Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
          <div className="card-body p-2">
            <Tabs
              activeKey={selectedTab}
              onSelect={handleTabOnSelect}
              id="uncontrolled-tab-example"
              className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
            >
              <Tab eventKey="home" title="Recruiters"
                tabClassName="page-tab border border-left-0 border-top-0">
                <Tab.Content className="border border-top-0">
                  <div className="table-responsive">
                    {/* <button className="btn btn-sm btn-link" onClick={handleResetSelection}>Reset Selection</button> */}
                    <table className="table align-items-center table-flush table-hover mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Select <span style={{ cursor: "pointer" }} onClick={handleResetSelection}>
                            <i className="fa fa-refresh ml-2 text-primary" aria-hidden="true"></i>
                          </span></th>
                          <th>ID</th>
                          <th>Recruiter</th>
                          <th>Application</th>
                          {type !== "partner" && <th>Key Contact</th>}
                          <th>Enrollment Status</th>
                          {type === "partner" && <><th>Total User</th> <th>Status</th></>}
                          
                        </tr>
                      </thead>
                      <tbody>
                        {recruiters.map((item, key) => (
                          <>
                            <tr className={`${(selectedKey !== key && selectedKey !== -1) || (selectedFormKey !== key && selectedFormKey !== -1) ? "d-none" : ""}`}>
                              <td>
                                <div className="custom-control custom-radio">
                                  <input
                                    className="custom-control-input"
                                    type="radio"
                                    aria-label="Select Recruiter"
                                    id={item.fuid}
                                    name="recruiter"
                                    onChange={() => handleSelectRecruiter(item)}
                                    value={selectedRecruiterId}
                                    checked={selectedRecruiterId === item.fuid}
                                  />
                                  <label
                                    className="custom-control-label"
                                    aria-label="Select Recruiter"
                                    htmlFor={item.fuid}
                                  >
                                  </label>
                                </div>
                              </td>
                              <td>
                                {item.fuid}
                              </td>
                              <td>

                                <button
                                  onClick={() => handleViewRecruiterForm("Recruiter", key, item)}
                                  className="btn p-0 btn-link btn-sm text-uppercase">
                                  {item.label}
                                </button>
                                <br />
                                <span>{type === "application" ? item?.email : item?.contact1?.performeremail}</span>
                                <br />
                                <Moment format="MMM Do YYYY h:mm a">
                                  {item.createdDate}
                                </Moment>
                              </td>

                              <td className="pb-0">
                                <div className="border p-0">
                                  {item.applications.map((app) => (
                                    <div key={app.applicationId} className="mb-3 text-center">
                                      {/* Application Info */}
                                      <div className="p-1">
                                        <span className="text-dark">
                                          {app.applicationId} - {app.applicationType}
                                        </span>
                                      </div>

                                      {/* Status Button */}
                                      <div className="mt-1">
                                        {type === "application" ? (
                                          <>
                                            {app.appSubmitted ? (
                                              <button
                                                onClick={() => handlePartnerApplication(item, app)}
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 btn-min-width"
                                              >
                                                Complete
                                              </button>
                                            ) : (
                                              <button
                                                onClick={() => handlePartnerApplication(item, app)}
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 bg-yellow btn-min-width"
                                              >
                                                Review
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {app.appSubmitted ? (
                                              <button
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 btn-min-width"
                                              >
                                                Complete
                                              </button>
                                            ) : (
                                              <button
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 bg-yellow btn-min-width"
                                              >
                                                Review
                                              </button>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </td>

                              {type !== "partner" && (
                                <td>
                                  {item.contact1 !== null && (
                                    <React.Fragment>
                                      <span className="text-uppercase">
                                        {item.contact1.performername}{" "}
                                        {item.contact1.lastName}
                                      </span>
                                      <br />
                                      <span>
                                        {item.contact1.performeremail}
                                      </span>
                                      <br />
                                      {item.contact1?.contactNo && getFormatedNumber(item.contact1.contactNo)}
                                    </React.Fragment>
                                  )}
                                </td>
                              )}

                              <td>
                                {item.enrollmentStatus && (
                                  "Complete"
                                )}
                                {!item.enrollmentStatus && (
                                  "Pending"
                                )}
                                <br />
                                {item.contact1 !== null && type === "partner" && !item.enrollmentStatus && (
                                  <React.Fragment>
                                    <button
                                      className="btn btn-sm btn-link p-0 "
                                      onClick={() =>
                                        handleRemainder(
                                          item.contact1.performerid
                                        )
                                      }
                                    >
                                      Send Reminder
                                    </button>{" "}
                                    <button
                                      className="btn btn-sm btn-link p-0 mt-1"
                                      title="View message"
                                      onClick={handleRemainderMessage}
                                    >
                                      <span className="badge badge-warning rounded-0 text-red">
                                        <i
                                          class="fa fa-envelope mr-1"
                                          aria-hidden="true"
                                        ></i>
                                        {!item.contact1.msgAlertCount ? 0 : item.contact1.msgAlertCount}
                                      </span>
                                    </button>
                                  </React.Fragment>
                                )}
                              </td>
                              {type === "partner" && (
                               <>
                                <td>
                                  {item.activeUsers}
                                </td>
                                 <td>
                                {item.contact1?.isActive === true && (
                                  <>
                                    <i
                                      className="fa fa-check text-success"
                                      style={{ fontSize: "15px" }}
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Activated
                                    {item.contact1.addedDateTime && (
                                      <>
                                        <br />
                                        <Moment format="MMM Do YYYY h:mm a">{item.contact1.addedDateTime}</Moment>
                                      </>
                                    )}
                                    <br />
                                  </>
                                )}
                                {item.contact1?.isActive === false && (
                                  <>
                                    <i
                                      className="fa fa-times text-danger"
                                      style={{ fontSize: "15px" }}
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Deactivated
                                    {item.contact1.addedDateTime && (
                                      <>
                                        <br />
                                        <Moment format="MMM Do YYYY h:mm a">{item.contact1.addedDateTime}</Moment>
                                      </>
                                    )}
                                    <br />
                                  </>
                                )}
                                {item.contact1?.isActive === null ? (
                                  <>
                                    To Activate
                                    {item.contact1.addedDateTime && (
                                      <>
                                        <br />
                                        <Moment format="MMM Do YYYY h:mm a">{item.contact1.addedDateTime}</Moment>
                                      </>
                                    )}
                                  </>
                                ):<button
                                  className="btn btn-sm btn-link p-0"
                                  onClick={() =>
                                    handleRemainder(
                                      item.contact1.performerid
                                    )
                                  }
                                >
                                  Resend
                                </button>}
                              </td>
                               </>
                              )}
                            </tr>
                            <tr className={`${(selectedKey !== key && selectedKey !== -1) || (selectedFormKey !== key && selectedFormKey !== -1) ? "d-none" : ""} text-white`}>
                              {item.applications.map((app, appKey) => (
                                appKey === 0 && <React.Fragment key={app.applicationId}>
                                  <td colSpan={2} className="border-0 pt-0 pb-0"></td>
                                  <td colSpan={1} className="border-0 pt-0 pb-0" >
                                    <>
                                      {type === "application" &&
                                        <td className="text-left pt-0 pl-0 border-0">
                                          <button
                                            onClick={() => handleDocumentViewShowHide("Document", key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            Send Contract Documents
                                          </button>
                                          <br />
                                          <button
                                            onClick={() => handleACHShowHide("ACH", "Recruiter", item, key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            ACH Information <span className="badge badge-pill badge-danger">{app?.achRequest}</span>
                                          </button>
                                          <br />
                                          <button
                                            onClick={() => handleInsuranceShowHide("Insurance", "Recruiter", item, key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            Insurance Information <span className="badge badge-pill badge-danger">{app?.insuranceRequest}</span>
                                          </button>
                                        </td>
                                      }
                                    </>
                                  </td>
                                  <td colSpan={4} className="border-0 pt-0 pb-0"></td>
                                </React.Fragment>
                              ))}
                            </tr>
                            <tr className={`${selectedKey === key ? "" : "d-none"}`}>
                              {selectedInfo === "Document" && selectedKey === key &&
                                <td colSpan={7} className="bg-white p-3">
                                  <div className="text-left mb-3 pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => handleCloseDocumentView("Document", -1, null)}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <Document
                                    documents={appDocuments}
                                    workflowTask={selectedCurrentTask}
                                    uploadType={"Recruiter"}
                                    app={selectedApp}
                                    item={item}
                                    viewType={""}
                                  />
                                </td>}
                              {selectedInfo === "ACH" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{achType} ACH Information</h3></div>
                                  <AchInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"recruiterList"}
                                    achType={achType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}
                              {selectedInfo === "Insurance" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{insuranceType} Insurance Information</h3></div>
                                  <InsuranseInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"recruiterList"}
                                    insuranceType={insuranceType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}
                            </tr>
                            {wfForm && selectedFormKey === key &&
                              <td colSpan={13} className="bg-white p-3">
                                <div className="text-left mb-3 pr-0">
                                  <button
                                    className="btn btn-sm btn-outline-default mb-4"
                                    onClick={() => handleViewRecruiterForm(`${viewFormType}`, -1, null)}
                                  >
                                    <i className="fa fa-times mr-2"></i>Close
                                  </button>
                                </div>
                                <WorkflowElement
                                  wfTask={wfTask}
                                  wfForm={wfForm}
                                  handleNextTask={handleNextTask}
                                  viewType={true}
                                  appSummary={false}
                                  codeVerified={true}
                                  wfTaskType={"form"}
                                  // actionType={"workflow"}
                                  updatedStateData={updatedStateData}
                                />
                              </td>}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {recruiters.length === 0 && dataType === 'filter' && <span style={{ color: "#f5365c" }}>No Result Found</span>}
                  </div>
                  {selectedKey === -1 && selectedFormKey === -1 &&
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    ></Pagination>
                  }
                </Tab.Content>
              </Tab>
              {type === "application" &&
                <Tab eventKey="addEditRecruiter" title={`${selectedRecruiterId === 0 ? "Add" : "Edit"} Recruiter`}
                  tabClassName="page-tab border border-left-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedTab === "addEditRecruiter" &&
                      <EditPartner selectedObj={selectedObj} type="Recruiter" handleAddEditRecruiter={handleAddEditRecruiter} selectedTab={selectedTab} />
                    }
                  </Tab.Content>
                </Tab>}
              {type === "partner" &&
                <Tab eventKey="status" title="Activate/Deactivate" tabClassName="page-tab border border-left-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedRecruiterId === 0 && <div className="">
                      <h3 className="text-danger mt-1"> Alert : Please select the Recruiter first</h3>
                    </div>}
                    {selectedRecruiterId > 0 &&
                      <ActiveDeactiveHistory selectedObj={selectedObj} type="partner" typeName="Recruiter" actionType={actionType} handlePermissionShowHide2={handlePermissionShowHide2} />}
                  </Tab.Content>
                </Tab>}
              {type === "partner" &&
                <Tab eventKey="users" title={<span onClick={handlePartnerPerformer}>Assign/Manage Users</span>}
                  tabClassName="page-tab border-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedRecruiterId === 0 &&
                      <div className="col-md-12">
                        <h3 className="text-danger mt-1"> Alert : Please select the Recruiter first</h3>
                      </div>
                    }
                  </Tab.Content>
                </Tab>}
            </Tabs>
          </div>
        </div>
      </div>

      {/* {showHide &&
        <EditPartner
          showHide={showHide}
          handleModalShowHide={handleModalShowHide}
          type="Recruiter"
          partner={selectedObj}
          updatePartner={updatePartner}
        ></EditPartner>}

      {logShowHide &&
        <ActiveDeactiveHistory
          logShowHide={logShowHide}
          handleLogShowHide={handleLogShowHide}
          selectedObj={selectedObj}
          type="partner"
          pageType="Recruiter"
          actionType={actionType}
        ></ActiveDeactiveHistory>} */}

      {remainderMsgShowHide &&
        <ReminderAlertMessage
          remainderMsgShowHide={remainderMsgShowHide}
          handleRemainderMessage={handleRemainderMessage}
        ></ReminderAlertMessage>}

    </React.Fragment>
  );
}
